import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api, { fmtDate } from "@/lib/api";
import { PageHeader, Pager, EmptyState } from "@/components/common";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function Audit() {
  const [page, setPage] = useState(1);
  const [entity, setEntity] = useState("");
  const { data } = useQuery({
    queryKey: ["audit", page, entity],
    queryFn: async () => (await api.get(`/admin/audit-logs?page=${page}&limit=50&entity=${entity === "all" ? "" : entity}`)).data,
  });

  return (
    <div data-testid="audit-page">
      <PageHeader title="Audit Logs" sub="Every sensitive action, timestamped. Secrets are never logged." testid="audit-title">
        <Select value={entity} onValueChange={(v) => { setEntity(v); setPage(1); }}>
          <SelectTrigger data-testid="audit-entity-filter" className="w-44 border-slate-700 bg-[#111827] text-slate-200">
            <SelectValue placeholder="All entities" />
          </SelectTrigger>
          <SelectContent className="border-slate-700 bg-[#111827] text-slate-200">
            {["all", "product", "agent", "order", "shipment", "return", "store", "settings", "marketplace_account", "integration_job"].map((e) => (
              <SelectItem key={e} value={e}>{e === "all" ? "All entities" : e.replace(/_/g, " ")}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </PageHeader>

      {!data?.items?.length ? <EmptyState title="No audit entries" /> : (
        <div className="overflow-x-auto rounded-xl border border-slate-800 bg-[#111827]">
          <table className="w-full text-left text-xs" data-testid="audit-table">
            <thead>
              <tr className="border-b border-slate-800 text-[10px] uppercase tracking-wider text-slate-500">
                <th className="px-4 py-3">Timestamp</th>
                <th className="px-4 py-3">User</th>
                <th className="px-4 py-3">Action</th>
                <th className="px-4 py-3">Entity</th>
                <th className="px-4 py-3">Details</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((l) => (
                <tr key={l.id} data-testid={`audit-row-${l.id}`} className="border-b border-slate-800/50 hover:bg-slate-900/40">
                  <td className="whitespace-nowrap px-4 py-2.5 font-mono text-[11px] text-slate-400">{fmtDate(l.created_at)}</td>
                  <td className="px-4 py-2.5 text-slate-300">{l.user_email}</td>
                  <td className="px-4 py-2.5"><span className="rounded bg-orange-500/10 px-1.5 py-0.5 font-medium text-orange-400">{l.action}</span></td>
                  <td className="px-4 py-2.5 text-slate-400">{l.entity}</td>
                  <td className="max-w-xs truncate px-4 py-2.5 font-mono text-[10px] text-slate-500">{JSON.stringify(l.new || l.old || {})}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {data && <Pager page={data.page} pages={data.pages} onPage={setPage} />}
    </div>
  );
}
